/**
 * tokens.ts
 * Tokens de diseño por rol de usuario.
 * Sin dependencias de React Native — valores CSS puros.
 */

export type AppRole = 'CONSUMER' | 'MARKETPLACE' | 'PROFESSIONAL';

export const UI_CONTEXT_THEMES = {
  CONSUMER: {
    primary:       '#FFD200',   // Amarillo Consumidor
    surface:       '#FFFFFF',
    background:    '#F8FAFC',   // Slate 50
    text:          '#1A1A1A',
    textSecondary: '#64748B',   // Slate 500
  },
  MARKETPLACE: {
    primary:       '#00A86B',   // Verde Marketplace
    surface:       '#F4F9F6',
    background:    '#EAF3ED',
    text:          '#0B2F1D',
    textSecondary: '#4A695B',
  },
  PROFESSIONAL: {
    primary:       '#0052CC',   // Azul Gestión Médica
    surface:       '#F0F4FA',
    background:    '#E2E8F0',   // Slate 200
    text:          '#0A2540',
    textSecondary: '#475569',
  },
} as const;

export type AppTheme = typeof UI_CONTEXT_THEMES[AppRole];
